import { datadogRum } from '@datadog/browser-rum'
import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import 'es6-symbol/implement';
import 'es6-promise/auto';
// Styles
import 'availity-uikit/scss/_bootstrap.scss';
import './index.scss';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { QueryClientProvider, QueryClient } from 'react-query';
import './Common/interceptor/interceptor-api';
import App from './App';

require('isomorphic-fetch');
datadogRum.init({
  applicationId: 'b2d24fa1-15e4-4779-8f24-a587cbdb85f1',
  clientToken: 'pub9a3b851fd1f79cc25e00612a5313cf2d',
  site: 'datadoghq.com',
  service: 'pf-qoc-ui',
  //  env: 'production',
  version: '1.0.0',
  sampleRate: 100,
  sessionReplaySampleRate: 100, // if not included, the default is 100
  trackResources: true,
  trackLongTasks: true,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask',
  allowedTracingOrigins: ["https://perf.aws-providerexperience.anthem.com/qualityofcare/NC/", "/https:\/\/.*\.perf.aws-providerexperience.anthem.com/qualityofcare/NC/\.com/", "https://prod.aws-providerexperience.anthem.com/qualityofcare/NC/","/https:\/\/.*\.prod.aws-providerexperience.anthem.com/qualityofcare/NC/\.com/" ]
})

// Create a client
const queryClient = new QueryClient();

const container = document.querySelector('#root');

const root = ReactDOMClient.createRoot(container);

root.render(<QueryClientProvider client={queryClient} contextSharing> <App /> </QueryClientProvider>);
